"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function invariant(condition, message, Err) {
    if (Err === void 0) { Err = Error; }
    if (!condition) {
        throw new Err(message);
    }
}
exports.invariant = invariant;



//////////////////
// WEBPACK FOOTER
// ./~/@formatjs/intl-utils/src/invariant.js
// module id = 356
// module chunks = 0 1 2 3 4 5